// import {
//   BlogDetailsContent,
//   BlogPostComment,
//   BlogPostDetailsWrapper,
//   BlogPostFooter,
//   PostShare,
//   PostTags,
//   RelatedPostItem,
//   RelatedPostItems,
//   RelatedPostTitle,
//   RelatedPostWrapper,
// } from "./templatesNarrow.style"
import {
  BlogPostDetailsWrapper,
  BlogPostFooter,
  PostShare,
  PostTags,
  RelatedPostItem,
  RelatedPostItems,
  RelatedPostTitle,
  RelatedPostWrapper,
} from "./templatesFull.style"
import {
  FacebookShareButton,
  RedditShareButton,
  TwitterShareButton,
} from "react-share"
import { IoLogoFacebook, IoLogoReddit, IoLogoTwitter } from "react-icons/io"
import { Link, graphql } from "gatsby"
// import Sidebar from '../containers/Sidebar';

import Layout from "../components/layout"
import PostCard from "../components/PostCard/postCard"
import PostDetails from "../components/PostDetails/postDetails"
import React from "react"
import SEO from "../components/seo"
import _ from "lodash"
import urljoin from "url-join"

class BlogPostTemplate extends React.Component {
  componentDidMount() {
    if (typeof window !== "undefined") {
      // Using canvas to draw box surrounding blockquotes
      // In markdown char > should trigger each time blue frame.
      // API: https://github.com/rough-stuff/rough-notation
      // let annotate = require("rough-notation")
      // const blockquotes = document.getElementsByTagName("blockquote")
      // for (let index = 0; index < blockquotes.length; index++) {
      //   const singleBlockquote = blockquotes[index]
      //   const annotation = annotate.annotate(singleBlockquote, {
      //     strokeWidth: 2,
      //     type: "box",
      //     color: "#007aff",
      //     animationDuration: "0",
      //   })
      //   annotation.show()
      // }
      // const as = document.querySelectorAll("p a")
      // for (let index = 0; index < as.length; index++) {
      //   const singleA = as[index]
      //   const annotation = annotate.annotate(singleA, {
      //     strokeWidth: 4,
      //     type: "underline",
      //     color: "#b5ffe7",
      //     animationDuration: "1000",
      //   })
      //   annotation.show()
      // }
    }
  }
  render() {
    const props = this.props
    const post = props.data.markdownRemark
    const { edges } = props.data.allMarkdownRemark
    const title = post.frontmatter.title
    const slug = post.fields.slug
    const siteUrl = props.data.site.siteMetadata.siteUrl
    const shareUrl = urljoin(siteUrl, slug)


    return (
      <Layout>
        <SEO
          title={post.frontmatter.title}
          description={post.frontmatter.description || post.excerpt}
          image={`${siteUrl.slice(0, siteUrl.length - 1)}${post.frontmatter.cover.publicURL}`}
        />
        <BlogPostDetailsWrapper>
        {/* <BlogDetailsContent> */}
          <PostDetails
            title={post.frontmatter.title}
            date={post.frontmatter.date}
            preview={
              post.frontmatter.cover == null
                ? null
                : post.frontmatter.cover.childImageSharp.fluid
            }
            description={post.html}
          />

          <BlogPostFooter>
            {post.frontmatter.tags == null ? null : (
              <PostTags className="post_tags">
                {post.frontmatter.tags.map((tag: string, index: number) => (
                  <Link key={index} to={`/tags/${_.kebabCase(tag)}/`}>
                    {`#${tag}`}
                  </Link>
                ))}
              </PostTags>
            )}
             <PostShare>
              <span>Care to Share?</span>
              <FacebookShareButton url={shareUrl} quote={post.excerpt}>
                <IoLogoFacebook />
              </FacebookShareButton>
              <TwitterShareButton url={shareUrl} title={title}>
                <IoLogoTwitter />
              </TwitterShareButton>
              <RedditShareButton
                url={shareUrl}
                title={`${post.frontmatter.title}`}
              >
                <IoLogoReddit />
              </RedditShareButton>
            </PostShare> 
          </BlogPostFooter>
        {/* </BlogDetailsContent> */}
        {/* <Sidebar /> */}
      </BlogPostDetailsWrapper>

        {edges.length !== 0 && (
          <RelatedPostWrapper>
            <RelatedPostTitle>Related Posts</RelatedPostTitle>
            <RelatedPostItems>
              {edges.map(({ node }: any) => (
                <RelatedPostItem key={node.fields.slug}>
                  <PostCard
                    title={node.frontmatter.title || node.fields.slug}
                    url={node.fields.slug}
                    image={
                      node.frontmatter.cover == null
                        ? null
                        : node.frontmatter.cover.childImageSharp.fluid
                    }
                    tags={node.frontmatter.tags}
                  />
                </RelatedPostItem>
              ))}
            </RelatedPostItems>
          </RelatedPostWrapper>
        )}
      </Layout>
    )
  }
}

export default BlogPostTemplate

export const pageQuery = graphql`
  query BlogPostBySlug($slug: String!, $tag: [String!]) {
    site {
      siteMetadata {
        siteUrl
      }
    }
    markdownRemark(fields: { slug: { eq: $slug } }) {
      id
      excerpt(pruneLength: 160)
      html
      fields {
        slug
      }
      frontmatter {
        title
        date(formatString: "DD MMM, YYYY")
        description
        tags
        cover {
          publicURL
          childImageSharp {
            fluid(maxWidth: 1170, quality: 90) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
    }
    allMarkdownRemark(
      limit: 3
      sort: { fields: [frontmatter___date], order: DESC }
      filter: {
        frontmatter: { tags: { in: $tag } }
        fields: { slug: { ne: $slug } }
      }
    ) {
      edges {
        node {
          fields {
            slug
          }
          frontmatter {
            title
            tags
            cover {
              publicURL
              childImageSharp {
                fluid(maxWidth: 370, maxHeight: 220, quality: 90) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
          }
        }
      }
    }
  }
`
